export const SupportLangs = [
  { label: 'English', key: 'en' },
  { label: 'Español', key: 'es' },
  { label: 'Bahasa Indonesia', key: 'id' }, // 印尼语		
  { label: 'Filipino', key: 'fil' }, // 菲律宾
  { label: 'Italiano', key: 'it' }, // 意大利语
  { label: 'Deutsch', key: 'de' }, // 德语
  { label: 'Français', key: 'fr' },
  { label: 'Português', key: 'pt' }, // 葡萄牙
  { label: '日本語', key: 'ja' },
  { label: '한국인', key: 'ko' },
  { label: 'Русский', key: 'ru' },
  { label: 'اللغة العربية', key: 'ar' }, // 阿拉伯语
  { label: 'українська', key: 'uk' }, // 乌克兰语
  { label: 'แบบไทย', key: 'th' }, // 泰语
  { label: '简体中文', key: 'zh-CN' },
  { label: '繁体中文', key: 'zh-TW' },

] as const

export const langCodes = SupportLangs.map(item => item.key) 
